module.exports = __webpack_public_path__ + "img/three-disabled-big.acf23a2b.svg";